import { render, staticRenderFns } from "./visa_structure.vue?vue&type=template&id=6f5f2f49&scoped=true"
import script from "./visa_structure.vue?vue&type=script&lang=js"
export * from "./visa_structure.vue?vue&type=script&lang=js"
import style0 from "./visa_structure.vue?vue&type=style&index=0&id=6f5f2f49&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f2f49",
  null
  
)

export default component.exports